import React, { useState } from "react";
import { Modal, TitleBar } from "@shopify/app-bridge-react";
import { Button, Card, Stack, TextContainer } from "@shopify/polaris";
import { BillingType } from "types/app-plan";
import copy from "content/copy.json";
import { useShop } from "contexts/Shop";
import { shopActions } from "store/shopStore";
import { storeConnect } from "appStore";

const {
  freePlanCardContent,
  freePlanCardModalCancel,
  freePlanCardModalConfirm,
  freePlanCardModalContent,
  freePlanCardModalTitle,
  freePlanCardTitle,
  freePlanOnTrialText,
  onFreePlanCardTitle
} = copy.account.freePlan;

function FreePlanCard() {
  const { app_plan, onTrial } = useShop();
  const onFreePlan = app_plan.billingType === BillingType.Free;
  const title =
    onFreePlan && !onTrial ? onFreePlanCardTitle : freePlanCardTitle;
  const showOnTrialMessage = onFreePlan && onTrial;

  return (
    <Card title={title}>
      <Card.Section>
        <Stack distribution="fill">
          <TextContainer>
            <p>{freePlanCardContent}</p>
          </TextContainer>
          {!onFreePlan && <ConnectedModal />}
          {showOnTrialMessage && (
            <Stack distribution="trailing">
              <Button disabled plain>
                {freePlanOnTrialText}
              </Button>
            </Stack>
          )}
        </Stack>
      </Card.Section>
    </Card>
  );
}

interface ActivateFreePlanModalProps {
  loading: boolean;
  deleteRecurringCharge: (payload: () => void) => void;
}

function ActivateFreePlanModal({
  deleteRecurringCharge
}: ActivateFreePlanModalProps) {
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClose = () => setModalOpen(false);
  const onError = () => {
    setLoading(false);
    handleClose();
  };
  async function confirmFreePlan() {
    setLoading(true);
    deleteRecurringCharge(onError);
  }

  return (
    <>
      <Stack distribution="trailing">
        <Button plain onClick={() => setModalOpen(true)} disabled={loading}>
          Activate plan
        </Button>
      </Stack>
      <Modal open={modalOpen} onHide={handleClose}>
        <Card>
          <Card.Section>
            <TextContainer>
              <p>{freePlanCardModalContent}</p>
            </TextContainer>
          </Card.Section>
        </Card>
        <TitleBar title={freePlanCardModalTitle}>
          <button
            variant="primary"
            onClick={confirmFreePlan}
            disabled={loading}
          >
            {freePlanCardModalConfirm}
          </button>
          <button onClick={handleClose}>{freePlanCardModalCancel}</button>
        </TitleBar>
      </Modal>
    </>
  );
}

const ConnectedModal = storeConnect(ActivateFreePlanModal, [], shopActions);

export default FreePlanCard;
